import React from "react";
import { Modal, Row, Form, Col, Button } from "react-bootstrap";
import Select from "react-select";
import { horas } from "./horas";
import cep from "cep-promise";
import { CadastrarCupons, EditarCupons } from "../../../providers/CuponsProvider";
import { GetEstabRegiao } from "../../../providers/EstabelecimentoProvider";
import Switch from "../../../components/Switch";

export default class CadastrarEditarModal extends React.Component {
  constructor(props) {
    super(props);
    this.final_states = ["tipos_desconto", "tipo_cupom", "dias", "tipo_regiao"];
    this.state = {
      tipos_desconto: [
        { label: "Frete Grátis", value: "frete_gratis" },
        { label: "Desconto no Frete", value: "frete" },
        { label: "Desconto no Pedido", value: "desconto" },
      ],
      tipo_cupom: [
        { label: "Condomínio", value: "condominio" },
        { label: "Selecionado", value: "selecionado" },
        { label: "Regional", value: "regional" },
      ],
      dias: [
        { label: "Segunda", value: 1, horarios_dia: [] },
        { label: "Terça", value: 2, horarios_dia: [] },
        { label: "Quarta", value: 3, horarios_dia: [] },
        { label: "Quinta", value: 4, horarios_dia: [] },
        { label: "Sexta", value: 5, horarios_dia: [] },
        { label: "Sabádo", value: 6, horarios_dia: [] },
      ],
      tipo_regiao: [
        { label: "Cidade", value: "cidade" },
        { label: "Bairro", value: "bairro" },
        { label: "Estado", value: "estado" },
      ],

      tipo_regiao_selecionada: {},
      tipo_desconto: "",
      tipo_cupom_selecionado: {},
      codigo: "",
      estabelecimentos_vinculados: [],
      data_validade: "",
      recurso: null,
      minimo: false,
      valor_minimo_pedido: null,
      descricao: "",

      //* Condomínio
      nome_condominio: "",
      endereco: "",
      dia_selecionado: [],
      tipo_horario: "livre",
      regiao: "",
      cep: "",
      estado: "",
      cidade: "",
      bairro: "",
      rua: "",
      ruaNumero: "",

      /** */
      limite_ativacoes_geral_form_error_input: "",
      limite_ativacoes_geral: "",
      limite_ativacoes_geral_form_border_color: "",

      numero_ativacoes_geral: 0,
      valor_desconto: 0,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (event) => this.setState({ [event.target.name]: event.target.value });

  getCEP = async (ceps) => {
    try {
      const cep_info = await cep(ceps);

      if (!cep_info.neighborhood || !cep_info.city || !cep_info.state) {
        this.props.handleShowAlert("CEP inconsistente, tente outro", "danger");
        return false;
      }
      this.setState({
        estado: cep_info.state,
        cidade: cep_info.city,
        bairro: cep_info.neighborhood,
        rua: cep_info.street,
        regiao: `${cep_info.neighborhood}, ${cep_info.city} - ${cep_info.state}`,
      });
      this.props.handleShowAlert("Pesquisa feita com sucesso", "success");
    } catch (error) {
      this.props.handleShowAlert("Erro no campo CEP", "danger");
    }
  };
  limparForm = () => {
    let new_states = {};
    for (let state in this.state)
      if (!this.final_states.includes(state)) new_states[state] = "";

    this.setState({ ...new_states });
  };
  getEstabRegiao = async () => {
    let send = "";
    let estabs = "";

    if (this.state.tipo_regiao_selecionada.value === "estado") {
      send = this.state.estado;
    } else if (this.state.tipo_regiao_selecionada.value === "cidade") {
      send = this.state.cidade;
    } else {
      send = this.state.bairro;
    }
    const estabelecimentos = await GetEstabRegiao(
      send,
      this.state.tipo_regiao_selecionada.value,
    );

    if (estabelecimentos.length === 0) {
      return this.setState({ estabelecimentos_vinculados: [""] });
    }
    estabelecimentos.map((a) => {
      estabs = [...estabs, { label: a.nome_fantasia, value: a._id }];
      this.setState({
        estabelecimentos_vinculados: estabs,
      });
    });
  };

  cadastrarEditarCupom = async (tipo_request) => {
    let estabelecimentos = [];

    if (
      this.state.tipo_cupom_selecionado.value === "condominio" &&
      !this.props.modoEditarEstab
    )
      estabelecimentos.push({
        estabelecimento: this.state.estabelecimentos_vinculados.value,
        valor_minimo_pedido: this.state.valor_minimo_pedido
          ? Number(this.state.valor_minimo_pedido)
          : null,
      });
    else
      for (let estabelecimento of this.state.estabelecimentos_vinculados)
        estabelecimentos.push({
          estabelecimento: estabelecimento.value,
          valor_minimo_pedido: this.state.valor_minimo_pedido
            ? Number(this.state.valor_minimo_pedido)
            : null,
        });

    let data_to_send = {
      ativo: true,
      tipo: this.state.tipo_cupom_selecionado.value,
      tipo_desconto: this.state.tipo_desconto_selecionado.value,
      codigo: this.state.codigo,
      descricao: this.state.descricao,
      recurso: this.state.recurso ? Number(this.state.recurso) : null,
      valor_desconto: this.state.valor_desconto
        ? Number(this.state.valor_desconto)
        : null,
      expirationDate: this.state.data_validade
        ? new Date(this.state.data_validade).toISOString()
        : null,
      estabelecimentos,
      valor_minimo_pedido: this.state.valor_minimo_pedido
        ? Number(this.state.valor_minimo_pedido)
        : null,
      descricao_regiao: this.state.regiao,
      regiao_tipo: this.state.tipo_regiao_selecionada.value,
      cep: this.state.cep,
    };

    if (this.state.tipo_cupom_selecionado.value === "condominio") {
      let dias_promocao = [];
      for (let dia of this.state.dia_selecionado) {
        dias_promocao.push({
          dia_promocao: dia.value,
          horarios_dia: dia.horarios_dia,
        });
      }

      data_to_send["condominio"] = {
        nome_condominio: this.state.nome_condominio,
        endereco: `${this.state.rua}, ${this.state.ruaNumero}, ${this.state.regiao}`,
        tipo_horario: this.state.tipo_horario || "livre",
        dias_promocao,
      };
    }
    try {
      if (tipo_request === "cadastrar") {
        await CadastrarCupons(data_to_send);
        this.props.handleShowAlert("Cupom cadastrado com sucesso", "success");
      } else {
        await EditarCupons(data_to_send, this.props.data._id);
        this.props.handleShowAlert("Cupom editado com sucesso", "success");
      }
      await this.props.atualizarListaCupons();
      this.limparForm();
      this.props.handleModal();
    } catch (error) {
      this.props.handleShowAlert(error.error, "error");
    }
  };
  componentDidUpdate = (previousProps, previousState) => {
    if (previousProps.data != this.props.data) {
      this.limparForm();
      if (Object.keys(this.props.data).length !== 0) {
        this.setState({ ...this.props.data });
        this.setState({ regiao: this.props.data.cep });
        this.setState({
          tipo_regiao_selecionada: {
            label: this.props.data.regiao_tipo,
            value: this.props.data.regiao_tipo,
          },
        });
        let estabelecimentos = [];
        this.props.data.estabelecimentos.map((estabelecimento) => {
          const estab = this.props.estabelecimentos.filter(
            (estb) => estb.estabelecimento._id == estabelecimento.estabelecimento._id,
          )[0];
          estabelecimentos.push({
            label: estab?.label ?? estabelecimento.estabelecimento.nome_fantasia,
            value: estabelecimento.estabelecimento._id,
          });
        });

        this.setState({
          data_validade: this.props.data.expirationDate,
          estabelecimentos_vinculados: estabelecimentos,
          tipo_cupom_selecionado: this.state.tipo_cupom.filter(
            (cupom) => cupom.value === this.props.data.tipo,
          )[0],
          tipo_desconto_selecionado: this.state.tipos_desconto.filter(
            (cupom) => cupom.value === this.props.data.tipo_desconto,
          )[0],
        });
        this.setState({
          ...this.props.data.condominio,
        });

        if (this.props.data.tipo === "condominio") {
          const condominio_info = this.props.data.condominio;
          let dias_promo = [];

          if (condominio_info.tipo_horario === "fixo") {
            dias_promo = condominio_info.dias_promocao.map(
              (day) => this.state.dias.filter((dia) => dia.value === day.dia_promocao)[0],
            );

            dias_promo.map(
              (dia, index) =>
                (dia.horarios_dia = condominio_info.dias_promocao[index].horarios_dia),
            );
          } else {
            dias_promo = condominio_info.dias_promocao.map(
              (dia_promocao) =>
                this.state.dias.filter((dia) => dia.value === dia_promocao)[0],
            );
          }

          this.setState({
            ...condominio_info,
            rua: condominio_info.endereco.split(",")[0]?.trim(),
            ruaNumero: condominio_info.endereco.split(",")[1]?.trim(),
            dia_selecionado: dias_promo,
          });
        }
        this.setState({
          valor_minimo_pedido:
            parseInt(this.props.data.estabelecimentos[0].valor_minimo_pedido) ?? null,
          minimo: true,
        });
      }
    }
  };
  render() {
    return (
      <Modal size="xl" show={this.props.show} onHide={this.props.handleModal}>
        <Modal.Header closeButton className="modalHeader">
          <Modal.Title>{this.props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>Escolha o tipo de desconto *</Form.Label>
                  <Select
                    placeholder="Tipo de desconto"
                    value={this.state.tipo_desconto_selecionado}
                    options={this.state.tipos_desconto}
                    onChange={(opt) => this.setState({ tipo_desconto_selecionado: opt })}
                    isClearable
                  />
                  <br></br>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>Escolha a categoria cupom *</Form.Label>
                  <Select
                    placeholder="Escolha a categoria do cupom"
                    value={this.state.tipo_cupom_selecionado}
                    options={this.state.tipo_cupom}
                    onChange={(opt) => this.setState({ tipo_cupom_selecionado: opt })}
                  />
                  <br></br>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>Nome/Código *</Form.Label>
                  <Form.Control
                    placeholder="Nome/Código do cupom"
                    value={this.state.codigo.toUpperCase()}
                    type="text"
                    name="codigo"
                    onChange={this.handleChange}
                  ></Form.Control>
                </Form.Group>
              </Col>
              {this.state.tipo_cupom_selecionado.value === "condominio" ? (
                <Col>
                  <Form.Group>
                    <Form.Label>Nome do Condomínio*</Form.Label>
                    <Form.Control
                      value={this.state.nome_condominio}
                      type="text"
                      name="nome_condominio"
                      onChange={this.handleChange}
                    ></Form.Control>
                    <br></br>
                  </Form.Group>
                </Col>
              ) : null}
            </Row>
            {this.state.tipo_cupom_selecionado.value === "condominio" ? (
              <>
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Label>Dias de Desconto*</Form.Label>
                      <Select
                        placeholder="Escolha os dias das semana"
                        value={this.state.dia_selecionado}
                        isMulti
                        options={this.state.dias}
                        onChange={(opt) => this.setState({ dia_selecionado: opt })}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Switch
                      checked={this.state.tipo_horario === "fixo" ? true : false}
                      disabled={false}
                      onChange={(e) =>
                        this.setState({
                          tipo_horario: e.target.checked ? "fixo" : "livre",
                        })
                      }
                    />
                    <span>
                      Horário: {this.state.tipo_horario === "fixo" ? "Fixo" : "Livre"}
                    </span>
                    {this.state.tipo_horario &&
                    this.state.dia_selecionado.length > 0 &&
                    this.state.tipo_horario === "fixo" ? (
                      <Form.Group>
                        <Form.Label>Horários de entrega*</Form.Label>
                        <Row>
                          {this.state.dia_selecionado.map((dia, index) => {
                            let horarios = [];
                            dia?.horarios_dia.map((d_h) =>
                              horarios.push({ label: d_h, value: d_h }),
                            );
                            return (
                              <Col>
                                <Form.Label>{dia?.label}</Form.Label>
                                <Select
                                  placeholder="Selecione a hora"
                                  value={horarios}
                                  options={horas}
                                  isMulti
                                  onChange={(opt) => {
                                    let day = this.state.dia_selecionado;
                                    let hours = [];
                                    //day[index].horarios_dia = opt.value;
                                    opt.map((op) => hours.push(op.value));
                                    day[index].horarios_dia = hours;
                                    this.setState({ dia_selecionado: day });
                                  }}
                                  isClearable
                                />
                              </Col>
                            );
                          })}
                        </Row>
                      </Form.Group>
                    ) : null}
                  </Col>
                </Row>
              </>
            ) : null}
            {this.state.tipo_cupom_selecionado.value !== "selecionado" ? (
              <Row>
                <Col>
                  <Form.Group>
                    <Form.Label>Escolher região*</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.regiao}
                      placeholder="Digite o CEP"
                      onChange={(e) => {
                        if (e.target.value < 0) {
                          let valor = e.target.value * -1;
                          this.setState({ regiao: valor });
                          this.setState({ cep: e.target.value });
                          this.setState({ rua: "", ruaNumero: "" });
                        } else {
                          this.setState({ regiao: e.target.value });
                          this.setState({ cep: e.target.value });
                          this.setState({ rua: "", ruaNumero: "" });
                        }
                      }}
                      isClearable
                    />
                    <br></br>
                    <Button
                      variant="secondary"
                      onClick={(e) => {
                        this.setState({ regiao: "", cep: "" });
                      }}
                    >
                      Limpar
                    </Button>
                    <Button
                      style={{ "margin-left": "1em" }}
                      variant="primary"
                      onClick={(e) => {
                        this.getCEP(this.state.regiao);
                      }}
                    >
                      Pesquisar
                    </Button>
                  </Form.Group>
                </Col>
              </Row>
            ) : null}
            {this.state.tipo_cupom_selecionado.value === "regional" ? (
              <Row>
                <Col>
                  <Form.Group>
                    <Form.Label>Tipo de região*</Form.Label>
                    <Select
                      placeholder="Tipo de região"
                      value={this.state.tipo_regiao_selecionada}
                      options={this.state.tipo_regiao}
                      onChange={(opt) => this.setState({ tipo_regiao_selecionada: opt })}
                      isClearable
                    />
                    <br></br>

                    <Button
                      variant="primary"
                      onClick={(e) => {
                        this.getEstabRegiao(this.state.tipo_regiao_selecionada);
                      }}
                    >
                      Preencher Região
                    </Button>
                  </Form.Group>
                </Col>
              </Row>
            ) : null}
            {this.state.tipo_cupom_selecionado.value === "condominio" ? (
              <Row>
                <Col>
                  <Form.Group>
                    <Form.Label>Rua*</Form.Label>
                    <Form.Control
                      name="rua"
                      onChange={this.handleChange}
                      value={this.state.rua}
                      placeholder="Rua do condomínio"
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>Número*</Form.Label>
                    <Form.Control
                      name="ruaNumero"
                      onChange={this.handleChange}
                      value={this.state.ruaNumero}
                      placeholder="Número do condomínio"
                    />
                  </Form.Group>
                </Col>
              </Row>
            ) : null}

            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>Estabelecimento Vinculado*</Form.Label>
                  <Select
                    placeholder="Escolha o estabelecimento"
                    value={this.state.estabelecimentos_vinculados}
                    isMulti={
                      this.state.tipo_cupom_selecionado.value === "condominio"
                        ? false
                        : true
                    }
                    options={this.props.estabelecimentos}
                    onChange={(opt) => {
                      this.setState({ estabelecimentos_vinculados: opt });
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              {this.state.tipo_desconto_selecionado?.value !== "frete_gratis" ? (
                <Col>
                  <Form.Group>
                    <Form.Label>Valor do cupom *</Form.Label>
                    <Form.Control
                      value={this.state.valor_desconto}
                      type="number"
                      min={0}
                      placeholder="R$ 0,00"
                      onChange={(e) => {
                        if (e.target.value < 0) {
                          let valor = e.target.value * -1;
                          this.setState({ valor_desconto: valor });
                        } else {
                          this.setState({ valor_desconto: e.target.value });
                        }
                      }}
                    />
                  </Form.Group>
                </Col>
              ) : null}
              {this.state.tipo_cupom_selecionado.value !== "condominio" ? (
                <Col>
                  <Form.Group>
                    <Form.Label>Data de validade*</Form.Label>
                    <Form.Control
                      value={this.state.data_validade?.split("T")[0]}
                      type="date"
                      name="data_validade"
                      placeholder="21/10/2020"
                      onChange={this.handleChange}
                    />
                  </Form.Group>
                </Col>
              ) : null}
            </Row>
            <Form.Group>
              <Form.Label>
                Valor total do recurso *
                <br />
                {this.state.tipo_cupom_selecionado.value !== "condominio" ? (
                  <small style={{ color: "red" }}>
                    {this.state.limite_ativacoes_geral_form_error_input}
                  </small>
                ) : null}
              </Form.Label>

              <Form.Control
                value={this.state.recurso}
                type="number"
                min={this.state.valor_desconto}
                placeholder="R$ 00,00"
                onChange={(e) => {
                  const limite_ativacoes_geral = parseInt(
                    e.target.value / this.state.valor_desconto,
                  );
                  if (limite_ativacoes_geral < 1) {
                    this.setState({
                      limite_ativacoes_geral,
                      limite_ativacoes_geral_form_border_color: "red",
                      limite_ativacoes_geral_form_error_input:
                        "O valor do recurso deve ser maior ou igual ao valor do cupom",
                    });
                  } else {
                    this.setState({
                      limite_ativacoes_geral,
                      limite_ativacoes_geral_form_border_color: "green",
                      limite_ativacoes_geral_form_error_input: "",
                    });
                  }
                  if (e.target.value < 0) {
                    let valor = e.target.value * -1;
                    this.setState({ recurso: valor });
                  } else {
                    this.setState({ recurso: e.target.value });
                  }
                }}
              />
            </Form.Group>
            {this.state.tipo_desconto_selecionado?.value !== "frete_gratis" ? (
              <Form.Group>
                <Form.Label>Ativações disponíveis</Form.Label>
                <Form.Control
                  value={parseInt(
                    this.state.recurso / this.state.valor_desconto -
                      this.state.numero_ativacoes_geral * this.state.valor_desconto,
                  )}
                  type="number"
                  min={0}
                  disabled
                  placeholder="0"
                  style={{
                    "border-color": this.state.limite_ativacoes_geral_form_border_color,
                  }}
                />
              </Form.Group>
            ) : null}

            <Switch
              checked={this.state.minimo}
              disabled={false}
              onChange={(e) =>
                this.setState({
                  minimo: e.target.checked,
                })
              }
            />
            <span>Valor minimo?: {this.state.minimo ? "Sim" : "Não"}</span>
            {this.state.minimo ? (
              <Form.Group>
                <Form.Label>Valor minimo de pedido*</Form.Label>
                <Form.Control
                  value={this.state.valor_minimo_pedido}
                  type="number"
                  min={0}
                  placeholder="R$ 0,00"
                  onChange={(e) => {
                    this.setState({ valor_minimo_pedido: e.target.value });
                  }}
                />
              </Form.Group>
            ) : null}
            <Form.Group>
              <Form.Label>Descrição* </Form.Label>
              <Form.Control
                value={this.state.descricao}
                as="textarea"
                rows="4"
                type="text"
                onChange={(e) => {
                  this.setState({ descricao: e.target.value });
                }}
              ></Form.Control>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => this.props.handleModal()}>
            Fechar
          </Button>
          {this.props.modoEditarEstab ? (
            <Button variant="primary" onClick={() => this.cadastrarEditarCupom("editar")}>
              {"Editar"}
            </Button>
          ) : (
            <Button
              variant="primary"
              onClick={() => this.cadastrarEditarCupom("cadastrar")}
            >
              {"Cadastrar"}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}
